/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Upgrade1Inputs */

const zh_chat_insufficientcredits_upgrade1 = /** @type {(inputs: Chat_Insufficientcredits_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级订阅`)
};

const en_chat_insufficientcredits_upgrade1 = /** @type {(inputs: Chat_Insufficientcredits_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Subscription`)
};

const es_chat_insufficientcredits_upgrade1 = /** @type {(inputs: Chat_Insufficientcredits_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar suscripción`)
};

/**
* | output |
* | --- |
* | "Upgrade Subscription" |
*
* @param {Chat_Insufficientcredits_Upgrade1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_upgrade1 = /** @type {((inputs?: Chat_Insufficientcredits_Upgrade1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Upgrade1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_upgrade1(inputs)
	if (locale === "en") return en_chat_insufficientcredits_upgrade1(inputs)
	return es_chat_insufficientcredits_upgrade1(inputs)
});
export { chat_insufficientcredits_upgrade1 as "chat_insufficientCredits_upgrade" }